import React, { useState, useRef, useEffect } from 'react';
import './PaypalBtn.css';

function PaypalBtn() {

    const [paidFor, setPaidFor] = useState(false);
    const [error, setError] = useState(null);
    const paypalRef = useRef();
    
    useEffect(() => {
      window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  description: 'Join me, let me guide you to your own potential and see yourself accomplishing the goals you set for yourself. ',
                  amount: {
                    currency_code: 'USD',
                    value: 2.99,
                  },
                },
              ],
            });
          },
          onApprove: async (data, actions) => {
            const order = await actions.order.capture();
            setPaidFor(true);
            // console.log(order);
          },
          onError: err => {
            setError(err);
            console.error(err);
          },
        })
        .render(paypalRef.current);
    }, ['Join me, let me guide you to your own potential and see yourself accomplishing the goals you set for yourself. ', 2.99]);
  
    if (paidFor) {
      
       
        window.location = 'https://natural-seducer.web.app/download12365hgf8469475qopeldnsjdedsdd18z4f5ezfezdz54sz98d4dsqdfe846';
       
    }
  
    return (
      <div id="paypalBtn">
        <div ref={paypalRef} />
      </div>
    );
}

export default PaypalBtn;
